<script setup lang="ts">
import { useNuxtApp } from "#app";

const props = defineProps({
    content: Object,
});

const text = useNuxtApp().useMarked().parse(props.content?.text);
</script>

<template>
    <div class="text-base w-[100%] leading-7 lg:w-7/12 my-4 mx-auto" v-html="text"></div>
</template>